import { client } from "./index";

// Saves a banner from the Marketing tab and returns { url } to share
export const saveBanner = (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return client.post("/admin/marketing/banners", formData);
};

// Growth Strategy & Playbook analysis APIs
export const getStrategyAnalysis = () => client.get("/admin/marketing/strategy-analysis");
export const reanalyzeStrategy = () => client.post("/admin/marketing/reanalyze");
export const toggleChecklistItem = (itemKey, completed) =>
  client.post("/admin/marketing/checklist/toggle", { itemKey, completed });
